import { useEffect, useState } from 'react';
import { NodeViewWrapper, NodeViewProps } from '@tiptap/react';

import { Center, chakra, Flex, Spinner } from '@chakra-ui/react';
import { PersonaNodeWrapper } from '../PersonaNodeWrapper';
import ReactPlayer from 'react-player/youtube';
import { useTiptapFileSrc } from '@duke-hq/ui/components/DukeTiptapEditor/useTiptapFileSrc';

export function ResizableMediaNodeView(props: NodeViewProps) {
  const { node } = props;
  const [mediaType, setMediaType] = useState<'img' | 'video' | 'gif' | 'youtube'>();

  const src = node.attrs.src as string | null;
  const width = node.attrs.width;
  const height = node.attrs.height;
  const fileDrn = node.attrs.fileDrn;
  const fileUrl = useTiptapFileSrc(fileDrn, `/files/${src ?? ''}`);

  useEffect(() => {
    setMediaType(node.attrs['media-type']);
  }, [node.attrs]);

  return (
    <NodeViewWrapper as="article" style={{ width: '100%', margin: 0 }}>
      <PersonaNodeWrapper {...props}>
        {/* minW 0 lets the flex item shrink below the media's intrinsic width,
            and maxW 100% keeps the media inside its conversation bubble
            (mirroring the static card's render). */}
        <Flex contentEditable={false} position="relative" role="group" minW={0} maxW="100%">
          {/* Images render like the student runtime everywhere (canvas bubbles
              and the simulation/unit previews): clamped to the bubble width
              with the height left auto, so clamping never squashes the aspect
              ratio the way a pinned stored height would. */}
          {/* NOTE: Giphy images  */}
          {mediaType === 'gif' && (
            <chakra.img
              src={`${src}`}
              width={width}
              height="auto"
              borderRadius="lg"
              maxW="100%"
              draggable
              data-drag-handle
            />
          )}

          {/* NOTE: Images (not-Giphy) uploaded to S3  */}
          {mediaType === 'img' && src ? (
            <chakra.img
              src={fileUrl}
              width={width}
              height="auto"
              borderRadius="lg"
              maxW="100%"
              draggable
              data-drag-handle
            />
          ) : null}

          {mediaType === 'img' && src === null && (
            <Center w="300px" h="150px" bgColor="bg.muted">
              <Spinner />
            </Center>
          )}

          {/* NOTE: VIDEOS  */}
          {mediaType === 'video' && src ? (
            <chakra.video
              borderRadius="lg"
              controls
              width={width}
              height={height}
              maxW="100%"
              autoPlay={props.extension.options.autoPlay}
              onEnded={props.extension.options.onVideoComplete}
              onPlaying={props.extension.options.onPlaying}
              onLoadStart={props.extension.options.onPlaying}
              id="myVideo"
            >
              <source src={fileUrl} />
            </chakra.video>
          ) : null}

          {mediaType === 'video' && src === null && (
            <Center w="300px" h="150px" bgColor="bg.muted">
              <Spinner />
            </Center>
          )}
          {mediaType === 'youtube' && src ? (
            <ReactPlayer
              className="react-player"
              url={node.attrs.src}
              width="100%"
              height="100%"
              controls={true}
              onPlay={props.extension.options.onPlaying}
              onReady={props.extension.options.onReady}
              onEnded={props.extension.options.onVideoComplete}
            />
          ) : null}
        </Flex>
      </PersonaNodeWrapper>
    </NodeViewWrapper>
  );
}
